export default () => ({
    filters: {
        // Сезон
        season: [],
    },
    default_filters: {
        // Сезон
        season: [],
    },
    _abortController: null,
    state: {
        // Флаг инициализации компонента
        is_initialized: false,

        // Флаг изменения активной записи истории
        from_popstate: false,

        // Контейнер для контента с пагинацией
        paged_content_element: null,

        // Значение сдвига полосы прокрутки
        loading_scroll_top: 0,

        // Язык
        lang: 'ru',

        // Номер текущей страницы
        page: 1,

        // Флаг загрузки
        is_loading: false,

        // Флаг необходимости повторной загрузки (поменялись фильтры)
        is_need_to_load: false,

        // Флаг наличия следующей страницы
        has_next_page: false,

        // URL следующей страницы для ссылки (могут открыть в новой вкладке)
        next_page_url: '',

        // Базовый URL запроса, добавляется перед маршрутом
        base_url: '',

        // Маршрут запроса
        route: '',

        // Развернуть фильтры на мобильном экране?
        show_filters: false,
    },

    init() {
        // noinspection JSUnresolvedReference
        const { state: stateData, filters: filtersData } = JSON.parse(this.$root.getAttribute('data-state'));

        this.initState(stateData);
        Object.assign(this.filters, filtersData);
        this.initFilters();
        this.handlePopState();

        // Таймаут для инициализации фильтров
        setTimeout(() => {
            this.loadPage(1);
            this.state.is_initialized = true;
        }, 100);
    },

    initState(stateData) {
        // noinspection JSUnresolvedReference
        this.state.paged_content_element = this.$root.querySelector('#paged_content');

        if (!this.state.paged_content_element) {
            throw new Error('Не удалось найти контейнер для контента с пагинацией');
        }

        this.state.lang          = stateData.lang;
        this.state.page          = stateData.page;
        this.state.has_next_page = stateData.has_next_page;
        this.state.next_page_url = stateData.next_page_url;
        this.state.base_url      = stateData.base_url.replace(/\/$/, '');
        this.state.route         = stateData.route.replace(/\/$/, '');
    },

    initFilters() {

        const debouncedLoadPage = Alpine.debounce(this.loadPage.bind(this), 500);

        Alpine.nextTick().then(() => {
            Alpine.nextTick().then(() => {
                // noinspection JSUnresolvedReference
                this.$watch('filters', (value, oldValue) => {

                    console.debug('Значение фильтров обновилось (value, oldValue):', value, oldValue);

                    this.state.is_need_to_load = true;

                    // history

                    let searchParamsData = this.getSearchParamsData()

                    const historySearchParams = new URLSearchParams(searchParamsData).toString().replace(/%2C/g, ',');

                    if (!this.state.from_popstate) {

                        const data = JSON.parse(JSON.stringify(this.filters));

                        const url = this.state.base_url + this.state.route + '?' + historySearchParams;

                        history.pushState(data, window.title, url);
                    }

                    // load debounced

                    debouncedLoadPage(1, this.state.from_popstate, false);
                });

                // noinspection JSUnresolvedReference
                this.$watch('filters.season', () => {
                    this.state.show_filters = false;
                });
            });
        });
    },

    getSearchParamsData() {

        let data = {}

        // Сезон
        const season = this.filters.season.join(',');

        if (season.length) {
            data.season = season;
        }

        return data;
    },

    handlePopState() {

        // Обработчик события изменения URL
        window.addEventListener('popstate', (event) => {

            this.state.from_popstate = true;

            this.state.page = 1;

            for (let key in this.filters) {
                if (this.default_filters.hasOwnProperty(key)) {
                    this.filters[key] = this.default_filters[key];
                }
            }

            if (event.state) {
                for (let key in this.filters) {
                    if (event.state.hasOwnProperty(key)) {
                        this.filters[key] = event.state[key];
                    }
                }
            }
        });
    },

    loadPage(page, from_popstate = false, focus = true) {
        console.debug('Load page ' + page, from_popstate);

        // Сброс значения popstate
        this.state.from_popstate = false;

        // Сброс флага необходимости загрузки
        this.state.is_need_to_load = false;

        if (this.state.is_loading) {
            if (page > 1) {
                this.state.is_need_to_load = true;
                console.debug('Загрузка страницы уже выполняется');
                return;
            }
            this._abortController?.abort();
        }

        if (page > this.state.page && !this.state.has_next_page) {
            console.debug('Нет такой страницы');
            return;
        }

        this.state.is_loading = true;
        this.state.page       = page;

        let routePaged = this.state.route;

        if (this.state.page > 1) {
            routePaged += '/page/' + this.state.page;
        } else {
            this.clearPagedContainer('Загрузка с новой страницы');
        }

        if (focus) {
            this.focusLastItem();
        }

        // Сохранить положение прокрутки
        this.state.loading_scroll_top = window.scrollY;

        // Восстановить положение прокрутки
        window.scrollTo(0, this.state.loading_scroll_top);

        // Параметры запроса
        let searchParamsData = this.getSearchParamsData()

        searchParamsData.json = 1;

        const controller = new AbortController();
        this._abortController = controller;

        // noinspection JSCheckFunctionSignatures
        axios.get(routePaged, {

            baseURL: this.state.base_url,

            params: searchParamsData,

            signal: controller.signal,

            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },

        }).then(response => {

            this.state.page = response.data.page ?? 1;

            if (this.state.page === 1) {
                this.clearPagedContainer('Сброс пагинации');
            }

            this.removeSkeletons();

            this.state.paged_content_element.insertAdjacentHTML('beforeend', response.data.content ?? '');

            this.state.has_next_page = response.data.has_next_page ?? false;

            this.state.next_page_url = response.data.next_page_url ?? '';

        }).catch(error => {
            if (axios.isCancel(error)) return;
            console.error(error);
        }).finally(() => {
            if (this._abortController !== controller) return;

            this.removeSkeletons();

            this.state.is_loading = false;

            // Если во время загрузки фильтры поменялись
            if (this.state.is_need_to_load) {
                this.state.is_need_to_load = false;
                this.loadPage(1, false, false);
            }

        });
    },

    removeSkeletons() {
        console.debug('removeSkeletons');

        const skeletonElements = this.state.paged_content_element.querySelectorAll('[data-skeleton]');
        skeletonElements.forEach(element => {
            element.remove();
            console.debug('skeleton removed');
        });

        console.debug('removeSkeletons done');
    },

    clearPagedContainer(reason) {
        console.debug('clearPagedContainer', reason);

        this.state.paged_content_element.innerHTML = '';
    },

    focusLastItem() {
        const lastLink = this.state.paged_content_element.querySelector('.group\\/card:last-child a');

        if (!lastLink) {
            console.debug('last link not found - nothing to focus');
            return;
        }

        lastLink.focus({
            preventScroll: true
        });
    },

    toggleFilters() {
        this.state.show_filters = !this.state.show_filters;
    },

    hasActiveFilters() {

        return this.filters.season.length;
    },
})
